// ASVAB Quizzes - Professional Practice Questions with Comprehensive Coverage

const quizzes = [
  {
    id: 1,
    title: "Combat Operations: Arithmetic Reasoning",
    description: "Master tactical calculations essential for mission success",
    category: "Arithmetic Reasoning",
    timeLimit: 15, // minutes
    questions: [
      {
        id: 1,
        question: "A squad requires 2 MREs (Meals Ready-to-Eat) per day to sustain 24 hours of operations. For a 60-hour extended mission, how many MREs are needed?",
        options: [
          "3 MREs",
          "4 MREs",
          "5 MREs",
          "6 MREs"
        ],
        correctAnswer: 2, // index of correct answer (5 MREs)
        explanation: "Set up proportion: 2 MREs / 24 hours = x MREs / 60 hours. Cross multiply: 24x = 120. Divide: x = 5 MREs required for extended operations"
      },
      {
        id: 2,
        question: "A military equipment supplier adds a 40% markup to cost. If body armor costs $50 to manufacture, what is the selling price to the military?",
        options: [
          "$60",
          "$65",
          "$70",
          "$75"
        ],
        correctAnswer: 2, // $70
        explanation: "Calculate markup: 0.40 × $50 = $20. Add to base cost: $50 + $20 = $70 selling price"
      },
      {
        id: 3,
        question: "A convoy travels 300 miles across hostile territory in 5 hours. What is the average speed?",
        options: [
          "50 mph",
          "55 mph",
          "60 mph",
          "65 mph"
        ],
        correctAnswer: 2, // 60 mph
        explanation: "Speed = Distance ÷ Time. 300 miles ÷ 5 hours = 60 mph average convoy speed"
      },
      {
        id: 4,
        question: "A fuel tank on an armored vehicle holds 500 gallons. If it's currently 3/5 full, how many gallons of fuel remain?",
        options: [
          "250 gallons",
          "300 gallons",
          "350 gallons",
          "400 gallons"
        ],
        correctAnswer: 1, // 300 gallons
        explanation: "Multiply fraction by total capacity: 3/5 × 500 = (3 × 500) ÷ 5 = 1500 ÷ 5 = 300 gallons available"
      },
      {
        id: 5,
        question: "A soldier receives combat pay of $15 per hour for 8 hours daily over a 5-day deployment. What is total combat pay earned?",
        options: [
          "$500",
          "$550",
          "$600",
          "$650"
        ],
        correctAnswer: 2, // $600
        explanation: "Calculate: $15/hour × 8 hours/day = $120/day. Then: $120/day × 5 days = $600 total combat pay"
      },
      {
        id: 6,
        question: "A shipment contains 36 ammunition magazines. If 1/4 are defective and fail inspection, how many magazines are mission-ready?",
        options: [
          "9",
          "18",
          "27",
          "30"
        ],
        correctAnswer: 2, // 27
        explanation: "If 1/4 defective, then 3/4 are operational. Calculate: 3/4 × 36 = 27 mission-ready magazines"
      },
      {
        id: 7,
        question: "A platoon loses 15% of its 80-soldier strength during a firefight. How many casualties occurred?",
        options: [
          "10 soldiers",
          "12 soldiers",
          "14 soldiers",
          "16 soldiers"
        ],
        correctAnswer: 1, // 12
        explanation: "Convert 15% to decimal (0.15) and multiply: 0.15 × 80 = 12 casualties sustained"
      },
      {
        id: 8,
        question: "A bunker's interior measures 12 feet in length and 10 feet in width. What is the total floor area in square feet?",
        options: [
          "100 sq ft",
          "110 sq ft",
          "120 sq ft",
          "130 sq ft"
        ],
        correctAnswer: 2, // 120 sq ft
        explanation: "Area of rectangle = length × width = 12 ft × 10 ft = 120 square feet of usable space"
      }
    ]
  },
  {
    id: 2,
    title: "Word Knowledge Fundamentals",
    description: "Build your vocabulary with common ASVAB words",
    category: "Word Knowledge",
    timeLimit: 10, // minutes
    questions: [
      {
        id: 1,
        question: "Cautious most nearly means:",
        options: [
          "Reckless",
          "Careful",
          "Confused",
          "Quick"
        ],
        correctAnswer: 1, // Careful
        explanation: "Cautious means showing care and attention, especially to avoid danger or mistakes. It is synonymous with careful."
      },
      {
        id: 2,
        question: "Deliberate most nearly means:",
        options: [
          "Accidental",
          "Hasty",
          "Intentional",
          "Random"
        ],
        correctAnswer: 2, // Intentional
        explanation: "Deliberate means done consciously and intentionally, with careful thought and consideration."
      },
      {
        id: 3,
        question: "Abundant most nearly means:",
        options: [
          "Scarce",
          "Plentiful",
          "Expensive",
          "Rare"
        ],
        correctAnswer: 1, // Plentiful
        explanation: "Abundant means existing in large quantities; more than enough. It is synonymous with plentiful."
      },
      {
        id: 4,
        question: "Impartial most nearly means:",
        options: [
          "Biased",
          "Unfair",
          "Neutral",
          "Prejudiced"
        ],
        correctAnswer: 2, // Neutral
        explanation: "Impartial means treating all sides equally; fair and not biased. It is synonymous with neutral."
      },
      {
        id: 5,
        question: "Conceal most nearly means:",
        options: [
          "Reveal",
          "Hide",
          "Show",
          "Display"
        ],
        correctAnswer: 1, // Hide
        explanation: "Conceal means to hide or keep something secret from view or knowledge."
      },
      {
        id: 6,
        question: "Resilient most nearly means:",
        options: [
          "Fragile",
          "Weak",
          "Tough",
          "Brittle"
        ],
        correctAnswer: 2, // Tough
        explanation: "Resilient means able to recover quickly from difficulties; tough and flexible."
      },
      {
        id: 7,
        question: "Elated most nearly means:",
        options: [
          "Sad",
          "Angry",
          "Joyful",
          "Worried"
        ],
        correctAnswer: 2, // Joyful
        explanation: "Elated means extremely happy or joyful, often due to success or good fortune."
      },
      {
        id: 8,
        question: "Validate most nearly means:",
        options: [
          "Reject",
          "Confirm",
          "Deny",
          "Question"
        ],
        correctAnswer: 1, // Confirm
        explanation: "Validate means to confirm the accuracy or validity of something; to prove something is true or correct."
      }
    ]
  },
  {
    id: 3,
    title: "General Science Essentials",
    description: "Test your knowledge of basic science concepts",
    category: "General Science",
    timeLimit: 12, // minutes
    questions: [
      {
        id: 1,
        question: "What is the chemical symbol for water?",
        options: [
          "O2",
          "H2O",
          "CO2",
          "H2O2"
        ],
        correctAnswer: 1, // H2O
        explanation: "Water's chemical formula is H2O, meaning two hydrogen atoms bonded to one oxygen atom."
      },
      {
        id: 2,
        question: "What organ in the human body pumps blood?",
        options: [
          "Liver",
          "Lungs",
          "Heart",
          "Kidneys"
        ],
        correctAnswer: 2, // Heart
        explanation: "The heart is a muscular organ that pumps blood throughout the body via the circulatory system."
      },
      {
        id: 3,
        question: "Which planet is closest to the Sun?",
        options: [
          "Venus",
          "Earth",
          "Mercury",
          "Mars"
        ],
        correctAnswer: 2, // Mercury
        explanation: "Mercury is the closest planet to the Sun, orbiting at an average distance of about 36 million miles."
      },
      {
        id: 4,
        question: "What gas do plants absorb from the atmosphere during photosynthesis?",
        options: [
          "Oxygen",
          "Nitrogen",
          "Carbon dioxide",
          "Hydrogen"
        ],
        correctAnswer: 2, // Carbon dioxide
        explanation: "Plants absorb carbon dioxide (CO2) from the air and use it along with water and sunlight to produce glucose and oxygen."
      },
      {
        id: 5,
        question: "What is the force that pulls objects toward Earth?",
        options: [
          "Magnetism",
          "Gravity",
          "Friction",
          "Inertia"
        ],
        correctAnswer: 1, // Gravity
        explanation: "Gravity is the force that attracts objects with mass toward each other. Earth's gravity pulls objects toward its center."
      },
      {
        id: 6,
        question: "Which type of energy is stored in food?",
        options: [
          "Kinetic energy",
          "Thermal energy",
          "Chemical energy",
          "Electrical energy"
        ],
        correctAnswer: 2, // Chemical energy
        explanation: "Food contains chemical energy stored in the bonds between atoms. This energy is released when food is digested."
      },
      {
        id: 7,
        question: "What is the basic unit of life?",
        options: [
          "Atom",
          "Cell",
          "Tissue",
          "Organ"
        ],
        correctAnswer: 1, // Cell
        explanation: "The cell is the basic structural and functional unit of all living organisms."
      },
      {
        id: 8,
        question: "What happens to water when it freezes?",
        options: [
          "It becomes denser",
          "It becomes less dense",
          "Its mass increases",
          "Its mass decreases"
        ],
        correctAnswer: 1, // It becomes less dense
        explanation: "When water freezes, it expands and becomes less dense. This is why ice floats on liquid water."
      }
    ]
  },
  {
    id: 4,
    title: "Mathematics Knowledge Mastery",
    description: "Practice algebra, geometry, and mathematical concepts",
    category: "Mathematics Knowledge",
    timeLimit: 15, // minutes
    questions: [
      {
        id: 1,
        question: "If 4x + 7 = 31, what is the value of x?",
        options: [
          "4",
          "5",
          "6",
          "7"
        ],
        correctAnswer: 2, // 6
        explanation: "Subtract 7 from both sides: 4x = 24. Divide by 4: x = 6"
      },
      {
        id: 2,
        question: "What is the area of a circle with radius 5?",
        options: [
          "25π",
          "10π",
          "50π",
          "15π"
        ],
        correctAnswer: 0, // 25π
        explanation: "Area of circle = πr². With r = 5: A = π(5²) = 25π square units"
      },
      {
        id: 3,
        question: "What is 45% of 200?",
        options: [
          "80",
          "90",
          "100",
          "110"
        ],
        correctAnswer: 1, // 90
        explanation: "Convert 45% to decimal (0.45) and multiply: 0.45 × 200 = 90"
      },
      {
        id: 4,
        question: "If a triangle has angles measuring 45° and 60°, what is the measure of the third angle?",
        options: [
          "65°",
          "70°",
          "75°",
          "80°"
        ],
        correctAnswer: 2, // 75°
        explanation: "The sum of angles in a triangle is 180°. So: 180° - 45° - 60° = 75°"
      },
      {
        id: 5,
        question: "What is the value of 2³ × 2²?",
        options: [
          "16",
          "32",
          "64",
          "128"
        ],
        correctAnswer: 1, // 32
        explanation: "When multiplying powers with the same base, add exponents: 2³ × 2² = 2⁵ = 32"
      },
      {
        id: 6,
        question: "If the perimeter of a square is 48, what is the length of one side?",
        options: [
          "8",
          "10",
          "12",
          "16"
        ],
        correctAnswer: 2, // 12
        explanation: "Perimeter of square = 4 × side. So: 48 = 4 × side, therefore side = 48 ÷ 4 = 12"
      },
      {
        id: 7,
        question: "What is the square root of 169?",
        options: [
          "11",
          "12",
          "13",
          "14"
        ],
        correctAnswer: 2, // 13
        explanation: "√169 = 13 because 13 × 13 = 169"
      },
      {
        id: 8,
        question: "If y = 2x + 3 and x = 4, what is the value of y?",
        options: [
          "9",
          "10",
          "11",
          "12"
        ],
        correctAnswer: 2, // 11
        explanation: "Substitute x = 4 into the equation: y = 2(4) + 3 = 8 + 3 = 11"
      }
    ]
  },
  {
    id: 5,
    title: "Electronics Information Fundamentals",
    description: "Test your knowledge of basic electricity and electronics",
    category: "Electronics Information",
    timeLimit: 12, // minutes
    questions: [
      {
        id: 1,
        question: "What is the unit of measurement for electrical power?",
        options: [
          "Volts",
          "Amperes",
          "Watts",
          "Ohms"
        ],
        correctAnswer: 2, // Watts
        explanation: "Electrical power is measured in Watts (W), named after James Watt. Power = Voltage × Current"
      },
      {
        id: 2,
        question: "In a parallel circuit with two 10Ω resistors, what is the total resistance?",
        options: [
          "5Ω",
          "10Ω",
          "20Ω",
          "40Ω"
        ],
        correctAnswer: 0, // 5Ω
        explanation: "In parallel: 1/Rtotal = 1/R1 + 1/R2 = 1/10 + 1/10 = 2/10. Therefore Rtotal = 10/2 = 5Ω"
      },
      {
        id: 3,
        question: "What does an insulator do in an electrical circuit?",
        options: [
          "Conducts electricity easily",
          "Stores electrical charge",
          "Prevents electricity from flowing",
          "Increases voltage"
        ],
        correctAnswer: 2, // Prevents electricity from flowing
        explanation: "An insulator is a material that resists the flow of electric current, preventing electricity from flowing where it shouldn't."
      },
      {
        id: 4,
        question: "If a circuit has 12 volts and 3 amperes, what is the resistance?",
        options: [
          "2 ohms",
          "4 ohms",
          "6 ohms",
          "9 ohms"
        ],
        correctAnswer: 1, // 4 ohms
        explanation: "Using Ohm's Law: R = V/I = 12V ÷ 3A = 4Ω"
      },
      {
        id: 5,
        question: "What is the primary function of a transformer?",
        options: [
          "Store electrical energy",
          "Convert AC to DC",
          "Change voltage levels",
          "Measure current"
        ],
        correctAnswer: 2, // Change voltage levels
        explanation: "A transformer changes AC voltage from one level to another (step up or step down) using electromagnetic induction."
      },
      {
        id: 6,
        question: "Which component allows current to flow in only one direction?",
        options: [
          "Resistor",
          "Capacitor",
          "Diode",
          "Inductor"
        ],
        correctAnswer: 2, // Diode
        explanation: "A diode is a semiconductor device that allows current to flow in one direction while blocking it in the opposite direction."
      },
      {
        id: 7,
        question: "What happens when you increase resistance in a circuit while keeping voltage constant?",
        options: [
          "Current increases",
          "Current decreases",
          "Current stays the same",
          "Voltage doubles"
        ],
        correctAnswer: 1, // Current decreases
        explanation: "According to Ohm's Law (I = V/R), if R increases and V stays constant, I (current) must decrease."
      },
      {
        id: 8,
        question: "What is the standard household voltage in the United States?",
        options: [
          "110-120V AC",
          "220-240V AC",
          "12V DC",
          "24V DC"
        ],
        correctAnswer: 0, // 110-120V AC
        explanation: "Standard US household voltage is approximately 110-120 volts of alternating current (AC) at 60 Hz."
      }
    ]
  },
  {
    id: 6,
    title: "Mechanical Comprehension Principles",
    description: "Master mechanical principles and simple machines",
    category: "Mechanical Comprehension",
    timeLimit: 15, // minutes
    questions: [
      {
        id: 1,
        question: "What is the mechanical advantage of a lever with the effort arm 4 feet long and the load arm 1 foot long?",
        options: [
          "2:1",
          "3:1",
          "4:1",
          "5:1"
        ],
        correctAnswer: 2, // 4:1
        explanation: "Mechanical Advantage = Length of effort arm ÷ Length of load arm = 4 ÷ 1 = 4:1"
      },
      {
        id: 2,
        question: "When two meshed gears rotate, if the driving gear turns clockwise, the driven gear turns:",
        options: [
          "Clockwise",
          "Counterclockwise",
          "In the same direction at twice the speed",
          "It doesn't move"
        ],
        correctAnswer: 1, // Counterclockwise
        explanation: "Meshed gears always rotate in opposite directions. If one goes clockwise, the other goes counterclockwise."
      },
      {
        id: 3,
        question: "What happens to the boiling point of water at higher altitudes?",
        options: [
          "It increases",
          "It decreases",
          "It stays the same",
          "Water cannot boil at high altitudes"
        ],
        correctAnswer: 1, // It decreases
        explanation: "At higher altitudes, atmospheric pressure is lower, so water boils at a lower temperature (below 212°F/100°C)."
      },
      {
        id: 4,
        question: "If a 10-pound weight is placed 5 feet from the fulcrum on one side of a balanced lever, how far from the fulcrum must a 25-pound weight be placed on the other side?",
        options: [
          "1 foot",
          "2 feet",
          "3 feet",
          "4 feet"
        ],
        correctAnswer: 1, // 2 feet
        explanation: "For balance: Weight1 × Distance1 = Weight2 × Distance2. So: 10 × 5 = 25 × D2. Therefore: D2 = 50 ÷ 25 = 2 feet"
      },
      {
        id: 5,
        question: "Which simple machine is a ramp or slanted surface?",
        options: [
          "Lever",
          "Pulley",
          "Inclined plane",
          "Wheel and axle"
        ],
        correctAnswer: 2, // Inclined plane
        explanation: "An inclined plane is a flat surface tilted at an angle, making it easier to move objects to a higher or lower level."
      },
      {
        id: 6,
        question: "What is the purpose of a flywheel in a machine?",
        options: [
          "Increase speed",
          "Store rotational energy and smooth motion",
          "Reduce weight",
          "Change direction"
        ],
        correctAnswer: 1, // Store rotational energy and smooth motion
        explanation: "A flywheel stores rotational energy and helps maintain smooth, consistent motion by resisting changes in rotational speed."
      },
      {
        id: 7,
        question: "If a wrench handle is 12 inches long and you apply 10 pounds of force, what torque are you applying?",
        options: [
          "60 inch-pounds",
          "90 inch-pounds",
          "120 inch-pounds",
          "150 inch-pounds"
        ],
        correctAnswer: 2, // 120 inch-pounds
        explanation: "Torque = Force × Distance = 10 pounds × 12 inches = 120 inch-pounds"
      },
      {
        id: 8,
        question: "What is friction?",
        options: [
          "The force that opposes motion between surfaces",
          "The force that pulls objects downward",
          "The force that pushes objects apart",
          "The force that keeps objects moving"
        ],
        correctAnswer: 0, // The force that opposes motion between surfaces
        explanation: "Friction is the resistance force that occurs when two surfaces slide or attempt to slide across each other."
      }
    ]
  },
  {
    id: 7,
    title: "Auto & Shop Information Essentials",
    description: "Automotive systems and shop tools knowledge",
    category: "Auto and Shop Information",
    timeLimit: 12, // minutes
    questions: [
      {
        id: 1,
        question: "What is the purpose of the carburetor or fuel injection system?",
        options: [
          "Cool the engine",
          "Mix air and fuel for combustion",
          "Filter exhaust gases",
          "Charge the battery"
        ],
        correctAnswer: 1, // Mix air and fuel for combustion
        explanation: "The carburetor or fuel injection system mixes air and fuel in the correct proportions for efficient combustion in the engine."
      },
      {
        id: 2,
        question: "What does SAE stand for in motor oil ratings like 'SAE 10W-30'?",
        options: [
          "Standard Automotive Equipment",
          "Society of Automotive Engineers",
          "Safe Automotive Energy",
          "System Analysis Evaluation"
        ],
        correctAnswer: 1, // Society of Automotive Engineers
        explanation: "SAE stands for Society of Automotive Engineers, the organization that developed the oil viscosity rating system."
      },
      {
        id: 3,
        question: "Which tool is used to remove and install spark plugs?",
        options: [
          "Allen wrench",
          "Torque wrench",
          "Spark plug socket",
          "Pipe wrench"
        ],
        correctAnswer: 2, // Spark plug socket
        explanation: "A spark plug socket is a specialized socket designed to grip spark plugs without damaging the ceramic insulator."
      },
      {
        id: 4,
        question: "What is the function of a vehicle's differential?",
        options: [
          "Change gears",
          "Allow wheels to rotate at different speeds while turning",
          "Start the engine",
          "Filter the oil"
        ],
        correctAnswer: 1, // Allow wheels to rotate at different speeds while turning
        explanation: "The differential allows the drive wheels to rotate at different speeds when turning, with the outer wheel traveling faster than the inner wheel."
      },
      {
        id: 5,
        question: "What type of hammer has a rounded face on one side and is used for metalwork?",
        options: [
          "Claw hammer",
          "Sledge hammer",
          "Ball-peen hammer",
          "Mallet"
        ],
        correctAnswer: 2, // Ball-peen hammer
        explanation: "A ball-peen hammer has a flat face on one side and a rounded (ball) face on the other, commonly used in metalworking."
      },
      {
        id: 6,
        question: "What does a thermostat in a car's cooling system do?",
        options: [
          "Measures air temperature",
          "Regulates engine temperature by controlling coolant flow",
          "Controls fuel mixture",
          "Adjusts tire pressure"
        ],
        correctAnswer: 1, // Regulates engine temperature by controlling coolant flow
        explanation: "The thermostat opens and closes to regulate coolant flow, maintaining optimal engine operating temperature."
      },
      {
        id: 7,
        question: "What is the proper safety device to wear when grinding metal?",
        options: [
          "Gloves only",
          "Safety glasses or face shield",
          "Earplugs",
          "Steel-toed boots"
        ],
        correctAnswer: 1, // Safety glasses or face shield
        explanation: "Safety glasses or a face shield protect your eyes and face from metal sparks, grinding dust, and flying particles."
      },
      {
        id: 8,
        question: "What is the purpose of a torque wrench?",
        options: [
          "Remove stripped bolts",
          "Tighten fasteners to a specific tightness",
          "Measure the length of bolts",
          "Cut through metal"
        ],
        correctAnswer: 1, // Tighten fasteners to a specific tightness
        explanation: "A torque wrench is designed to apply a specific amount of rotational force (torque) to ensure fasteners are tightened correctly without over-tightening."
      }
    ]
  },
  {
    id: 11,
    title: "Combat Electronics: Field Communication Systems",
    description: "Master electronic principles critical for military communications and equipment",
    category: "Electronics Information",
    timeLimit: 10,
    questions: [
      {
        id: 1,
        question: "A tactical radio operates at 12 volts and draws 2 amperes of current. According to Ohm's Law, what is the circuit's resistance?",
        options: [
          "4 ohms",
          "6 ohms",
          "10 ohms",
          "24 ohms"
        ],
        correctAnswer: 1,
        explanation: "Using Ohm's Law: R = V/I = 12V / 2A = 6 ohms. This fundamental relationship helps troubleshoot communication equipment in the field."
      },
      {
        id: 2,
        question: "What is the relationship between voltage, current, and resistance in an electrical circuit?",
        options: [
          "Voltage = Current / Resistance",
          "Voltage = Current × Resistance",
          "Voltage = Resistance / Current",
          "Voltage = Current + Resistance"
        ],
        correctAnswer: 1,
        explanation: "Ohm's Law states V = I × R (Voltage equals Current times Resistance). This is the foundation of all electrical circuit analysis and essential for military electronics technicians."
      },
      {
        id: 3,
        question: "What is the primary function of a resistor in an electronic circuit?",
        options: [
          "Store electrical charge",
          "Limit or control current flow",
          "Allow current in one direction only",
          "Amplify electrical signals"
        ],
        correctAnswer: 1,
        explanation: "Resistors limit or control the flow of electric current in a circuit. They're used to protect sensitive components, divide voltages, and set operating points in military electronics."
      },
      {
        id: 4,
        question: "A capacitor's primary function in a circuit is to:",
        options: [
          "Convert AC to DC power",
          "Amplify radio signals",
          "Store and release electrical energy",
          "Reduce circuit resistance"
        ],
        correctAnswer: 2,
        explanation: "Capacitors store electrical energy in an electric field and release it when needed. They're critical in power supplies, signal filtering, and timing circuits in military equipment."
      },
      {
        id: 5,
        question: "In a series circuit with three 10-ohm resistors, what is the total resistance?",
        options: [
          "3.33 ohms",
          "10 ohms",
          "20 ohms",
          "30 ohms"
        ],
        correctAnswer: 3,
        explanation: "In series circuits, total resistance equals the sum of individual resistances: Rtotal = R1 + R2 + R3 = 10 + 10 + 10 = 30 ohms. Current has only one path through all components."
      },
      {
        id: 6,
        question: "A parallel circuit has two branches with resistances of 20 ohms and 30 ohms. What is the total circuit resistance?",
        options: [
          "12 ohms",
          "25 ohms",
          "50 ohms",
          "600 ohms"
        ],
        correctAnswer: 0,
        explanation: "In parallel: 1/Rtotal = 1/R1 + 1/R2 = 1/20 + 1/30 = 3/60 + 2/60 = 5/60. Therefore Rtotal = 60/5 = 12 ohms. Parallel circuits provide multiple paths for current flow."
      },
      {
        id: 7,
        question: "What safety precaution is most important when working on electronic equipment?",
        options: [
          "Wear rubber gloves at all times",
          "Work in complete darkness",
          "Disconnect power and verify it's off before servicing",
          "Use only plastic tools"
        ],
        correctAnswer: 2,
        explanation: "Always disconnect power and verify it's off before working on electronics. Use a multimeter to confirm zero voltage. This prevents electric shock, which can be fatal, and protects equipment from damage."
      },
      {
        id: 8,
        question: "When troubleshooting a communication device that won't power on, what should you check first?",
        options: [
          "Replace all internal components",
          "Check power source, fuses, and connections",
          "Disassemble the entire unit",
          "Update the software"
        ],
        correctAnswer: 1,
        explanation: "Start with the basics: verify power source voltage, check fuses for continuity, inspect connections for corrosion or looseness. This systematic approach saves time and prevents unnecessary repairs in field conditions."
      }
    ]
  }
  ,
  {
    id: 16,
    title: "Military Vehicle Systems: Advanced Diagnostics",
    description: "Master advanced automotive and shop principles for tactical vehicles and equipment",
    category: "Auto and Shop Information",
    timeLimit: 12,
    questions: [
      {
        id: 1,
        question: "In a military vehicle's diesel engine, what is the primary function of the turbocharger?",
        options: [
          "Cool the engine oil",
          "Force more air into the cylinders to increase power",
          "Filter exhaust emissions",
          "Reduce fuel consumption by limiting air intake"
        ],
        correctAnswer: 1,
        explanation: "A turbocharger uses exhaust gases to spin a turbine that compresses incoming air, forcing more oxygen into the cylinders. This allows more fuel to be burned, significantly increasing power output without increasing engine displacement - critical for heavy military vehicles."
      },
      {
        id: 2,
        question: "What does a hydraulic torque converter do in an automatic transmission system?",
        options: [
          "Stores transmission fluid under pressure",
          "Transfers engine power to the transmission using fluid coupling",
          "Cools the transmission by circulating fluid",
          "Filters contaminants from transmission fluid"
        ],
        correctAnswer: 1,
        explanation: "The torque converter uses transmission fluid to transfer rotational force from the engine to the transmission without a mechanical connection. It acts as a fluid coupling that allows the engine to run while the vehicle is stopped and multiplies torque during acceleration - essential for smooth operation of heavy tactical vehicles."
      },
      {
        id: 3,
        question: "In a vehicle's charging system, if the alternator produces 14.2 volts at 50 amperes, what is the power output in watts?",
        options: [
          "350 watts",
          "520 watts",
          "710 watts",
          "850 watts"
        ],
        correctAnswer: 2,
        explanation: "Power (Watts) = Voltage × Current = 14.2V × 50A = 710 watts. Understanding electrical power calculations is essential for diagnosing charging system problems and determining if the alternator can support additional electrical equipment like radios and night vision systems."
      },
      {
        id: 4,
        question: "What causes 'brake fade' in a heavy military vehicle during prolonged downhill operation?",
        options: [
          "Loss of brake fluid pressure",
          "Excessive heat reducing friction between brake pads and rotors",
          "Air bubbles entering the brake lines",
          "Worn brake pad material contaminating the system"
        ],
        correctAnswer: 1,
        explanation: "Brake fade occurs when continuous braking generates excessive heat, reducing the coefficient of friction between brake pads and rotors. The pads become glazed and less effective. This is why military vehicles use engine braking and exhaust brakes on long descents to preserve brake effectiveness for emergencies."
      },
      {
        id: 5,
        question: "Which specialized tool is essential for measuring the torque specification on critical engine bolts like cylinder head bolts?",
        options: [
          "Impact wrench with torque limiter",
          "Beam-type torque wrench",
          "Click-type or digital torque wrench",
          "Breaker bar with extension"
        ],
        correctAnswer: 2,
        explanation: "A click-type or digital torque wrench provides accurate, repeatable torque measurement essential for critical fasteners. Cylinder head bolts require precise torque in a specific sequence to ensure proper gasket sealing and prevent warping. Over-tightening can damage threads or crack components; under-tightening causes leaks and failures."
      },
      {
        id: 6,
        question: "What is a feeler gauge used for in automotive maintenance?",
        options: [
          "Measuring cylinder bore diameter",
          "Checking fuel pressure levels",
          "Measuring small gaps and clearances like spark plug gaps",
          "Testing battery acid specific gravity"
        ],
        correctAnswer: 2,
        explanation: "A feeler gauge is a precision measuring tool consisting of thin metal blades of specific thicknesses. It's used to measure small gaps such as spark plug electrode gaps, valve clearances, and bearing clearances. Proper gap measurements ensure optimal engine performance and longevity in tactical vehicles."
      },
      {
        id: 7,
        question: "When working with a pressurized cooling system on a hot engine, what is the critical safety procedure?",
        options: [
          "Remove the radiator cap quickly to release pressure",
          "Wait for engine to cool, then slowly release pressure by loosening cap gradually",
          "Pour cold water directly onto the hot engine to cool it faster",
          "Disconnect the lower radiator hose to drain coolant"
        ],
        correctAnswer: 1,
        explanation: "Cooling systems operate under 15-20 PSI pressure, raising the boiling point to prevent overheating. Opening a hot pressurized system can cause violent boiling and spray scalding coolant. Always wait for the engine to cool below 150°F, then slowly loosen the cap to release pressure gradually before full removal - critical for preventing severe burns."
      },
      {
        id: 8,
        question: "If a micrometer reading shows 0.375 inches, what is this measurement equivalent to in decimal form when converted to thousandths?",
        options: [
          "37.5 thousandths",
          "375 thousandths",
          "3.75 thousandths",
          "3750 thousandths"
        ],
        correctAnswer: 1,
        explanation: "0.375 inches = 375 thousandths of an inch (or 375 'thou'). Machinists and mechanics use thousandths as the standard unit for precision measurements. Understanding decimal-to-thousandths conversion is essential for measuring cylinder bores, crankshaft journals, and bearing clearances where tolerances are typically 0.001-0.003 inches."
      }
    ]
  }
  ,
  {
    id: 17,
    title: "Advanced Scientific Operations: Military Applications",
    description: "Master advanced scientific principles essential for tactical operations and field analysis",
    category: "General Science",
    timeLimit: 15,
    questions: [
      {
        id: 1,
        question: "During high-altitude reconnaissance missions, pilots must understand how hemoglobin's oxygen-binding affinity changes with altitude. What physiological adaptation allows the body to compensate for lower oxygen partial pressure at high elevations?",
        options: [
          "Decreased red blood cell production",
          "Increased production of 2,3-BPG causing rightward shift in oxygen dissociation curve",
          "Reduced lung capacity to conserve energy",
          "Decreased heart rate to preserve oxygen"
        ],
        correctAnswer: 1,
        explanation: "At high altitudes, the body produces more 2,3-bisphosphoglycerate (2,3-BPG), which decreases hemoglobin's oxygen affinity. This rightward shift in the oxygen-hemoglobin dissociation curve facilitates oxygen release to tissues despite lower atmospheric oxygen levels. The body also increases red blood cell production (polycythemia) over time to enhance oxygen-carrying capacity."
      },
      {
        id: 2,
        question: "In a combat scenario, understanding trophic energy transfer is critical for survival training. Approximately what percentage of energy is transferred from one trophic level to the next in a typical ecosystem?",
        options: [
          "50%",
          "25%",
          "10%",
          "2%"
        ],
        correctAnswer: 2,
        explanation: "Only about 10% of energy is transferred between trophic levels, known as the 10% rule. The remaining 90% is lost as heat through metabolic processes. This ecological principle is crucial for survival training, as it explains why plant-based food sources are more energy-efficient than hunting large predators in survival situations."
      },
      {
        id: 3,
        question: "Military geneticists study inherited traits for personnel selection. If a trait is X-linked recessive and a carrier mother (XAXa) has children with an unaffected father (XAY), what is the probability their son will express the trait?",
        options: [
          "0%",
          "25%",
          "50%",
          "100%"
        ],
        correctAnswer: 2,
        explanation: "Sons receive their only X chromosome from their mother. A carrier mother (XAXa) has a 50% chance of passing the Xa chromosome to her son. Since males have only one X chromosome (XAY), receiving Xa means the son will express the recessive trait. Daughters would need two recessive alleles to express the trait, making them carriers at most in this scenario."
      },
      {
        id: 4,
        question: "Heat-seeking missiles utilize infrared detection based on thermodynamic principles. Which law of thermodynamics explains why heat naturally flows from the hot jet exhaust to cooler surroundings, making aircraft detectable?",
        options: [
          "Zeroth Law - thermal equilibrium",
          "First Law - conservation of energy",
          "Second Law - entropy always increases",
          "Third Law - absolute zero is unattainable"
        ],
        correctAnswer: 2,
        explanation: "The Second Law of Thermodynamics states that entropy increases in isolated systems, and heat spontaneously flows from hot to cold regions. This irreversible process creates the infrared signature that heat-seeking missiles detect. Modern aircraft use various countermeasures to disperse or mask this thermal signature."
      },
      {
        id: 5,
        question: "Naval sonar systems exploit wave properties for submarine detection. If sonar emits a 50 kHz sound wave in seawater where sound travels at 1,500 m/s, what is the wavelength?",
        options: [
          "0.03 meters",
          "0.3 meters",
          "3 meters",
          "30 meters"
        ],
        correctAnswer: 0,
        explanation: "Using the wave equation: wavelength (λ) = velocity (v) / frequency (f). λ = 1,500 m/s ÷ 50,000 Hz = 0.03 meters or 3 cm. Higher frequency sonar provides better resolution for detecting smaller objects but has shorter range due to increased absorption in water."
      },
      {
        id: 6,
        question: "Electromagnetic pulse (EMP) weapons exploit electromagnetic induction to disable electronics. According to Faraday's Law, what conditions maximize the induced voltage in a conducting loop?",
        options: [
          "Slow, steady magnetic field",
          "Static magnetic field with large area",
          "Rapid change in magnetic flux through the loop",
          "Weak magnetic field over long duration"
        ],
        correctAnswer: 2,
        explanation: "Faraday's Law states that induced voltage is proportional to the rate of change of magnetic flux. EMPs create extremely rapid magnetic field changes (nanoseconds), inducing large voltage spikes that damage electronic components. Military equipment uses Faraday cages and surge protection to mitigate EMP effects."
      },
      {
        id: 7,
        question: "Understanding atomic structure is essential for nuclear operations. How many neutrons are in an atom of Uranium-238, given that uranium has an atomic number of 92?",
        options: [
          "92",
          "146",
          "238",
          "330"
        ],
        correctAnswer: 1,
        explanation: "Number of neutrons = Mass number - Atomic number = 238 - 92 = 146 neutrons. U-238 is the most common uranium isotope. The atomic number (92) represents protons and defines the element, while the mass number (238) is the sum of protons and neutrons. U-235, with 143 neutrons, is the fissile isotope used in nuclear applications."
      },
      {
        id: 8,
        question: "Military explosives utilize rapid exothermic reactions. When TNT (C7H5N3O6) detonates, what type of chemical reaction occurs, and what drives the explosive force?",
        options: [
          "Endothermic reaction absorbing heat from surroundings",
          "Exothermic decomposition producing high-pressure gases and heat",
          "Neutralization reaction between acid and base",
          "Synthesis reaction combining simple molecules"
        ],
        correctAnswer: 1,
        explanation: "TNT undergoes rapid exothermic decomposition, breaking molecular bonds and releasing enormous energy as heat while producing large volumes of gas (CO2, H2O, N2). The sudden generation of hot, expanding gases creates the shock wave. The reaction is self-sustaining once initiated due to the heat released exceeding the activation energy needed."
      },
      {
        id: 9,
        question: "Weather prediction is critical for air operations. A cold front is approaching a warm, moist air mass. What weather conditions should pilots expect at the frontal boundary?",
        options: [
          "Clear skies and calm conditions",
          "Gradual temperature increase with light drizzle",
          "Severe thunderstorms, turbulence, and rapid temperature drop",
          "Fog and steady light rain for several days"
        ],
        correctAnswer: 2,
        explanation: "Cold fronts force warm, moist air to rise rapidly, creating instability. This produces towering cumulonimbus clouds, severe thunderstorms, heavy precipitation, strong winds, and turbulence along a narrow band. Temperature drops sharply as the front passes. These conditions are hazardous for aviation and require flight path adjustments or delays."
      },
      {
        id: 10,
        question: "GPS satellites orbit at approximately 20,200 km altitude. Understanding orbital mechanics is crucial for space operations. What provides the centripetal force that keeps satellites in circular orbit around Earth?",
        options: [
          "The satellite's engines providing continuous thrust",
          "Magnetic attraction between satellite and Earth",
          "Gravitational force from Earth pulling the satellite inward",
          "Air resistance pushing the satellite toward Earth"
        ],
        correctAnswer: 2,
        explanation: "Earth's gravitational force provides the centripetal acceleration needed for circular orbital motion. At orbital altitude, gravity is weaker but still sufficient to curve the satellite's path into a circle. The satellite's tangential velocity balances gravitational pull - if it were faster, it would escape; slower, it would fall. No engine thrust is needed to maintain orbit in the vacuum of space."
      }
    ]
  }
,
  {
    id: 8,
    title: "Military Science Operations",
    description: "Advanced science concepts for tactical applications",
    category: "General Science",
    timeLimit: 12,
    questions: [
      {
        id: 1,
        question: "Which component of blood is responsible for fighting infections and disease?",
        options: [
          "Red blood cells",
          "White blood cells",
          "Platelets",
          "Plasma"
        ],
        correctAnswer: 1,
        explanation: "White blood cells (leukocytes) are part of the immune system and defend the body against infections, bacteria, viruses, and foreign substances. Red blood cells carry oxygen, platelets help clotting, and plasma is the liquid component."
      },
      {
        id: 2,
        question: "What is the primary function of mitochondria in cells?",
        options: [
          "Store genetic information",
          "Produce proteins",
          "Generate energy (ATP)",
          "Break down waste materials"
        ],
        correctAnswer: 2,
        explanation: "Mitochondria are the powerhouses of the cell, converting nutrients into adenosine triphosphate (ATP), which cells use as energy. This process is called cellular respiration and is essential for all cellular functions."
      },
      {
        id: 3,
        question: "What happens when an acid reacts with a base?",
        options: [
          "They produce salt and water",
          "They produce oxygen gas",
          "They explode violently",
          "They form a stronger acid"
        ],
        correctAnswer: 0,
        explanation: "When an acid reacts with a base, they undergo a neutralization reaction, producing salt and water. For example, hydrochloric acid (HCl) reacting with sodium hydroxide (NaOH) produces sodium chloride (salt) and water."
      },
      {
        id: 4,
        question: "On the pH scale, what does a reading of 7 indicate?",
        options: [
          "Strong acid",
          "Weak acid",
          "Neutral",
          "Strong base"
        ],
        correctAnswer: 2,
        explanation: "The pH scale ranges from 0-14. A pH of 7 is neutral (like pure water). Values below 7 are acidic, and values above 7 are basic (alkaline). Each number represents a tenfold difference in hydrogen ion concentration."
      },
      {
        id: 5,
        question: "According to Newton's Third Law of Motion, for every action there is:",
        options: [
          "An equal increase in velocity",
          "An equal and opposite reaction",
          "A decrease in mass",
          "An increase in potential energy"
        ],
        correctAnswer: 1,
        explanation: "Newton's Third Law states that for every action, there is an equal and opposite reaction. When you push on a wall, the wall pushes back with equal force. This principle is critical in understanding rocket propulsion and recoil."
      },
      {
        id: 6,
        question: "What type of energy does a stretched rubber band possess?",
        options: [
          "Kinetic energy",
          "Thermal energy",
          "Potential energy",
          "Nuclear energy"
        ],
        correctAnswer: 2,
        explanation: "A stretched rubber band possesses elastic potential energy, which is stored mechanical energy. When released, this potential energy converts to kinetic energy (motion). This principle applies to springs, bows, and other elastic systems."
      },
      {
        id: 7,
        question: "What type of rock is formed from cooled and solidified lava or magma?",
        options: [
          "Sedimentary rock",
          "Metamorphic rock",
          "Igneous rock",
          "Limestone"
        ],
        correctAnswer: 2,
        explanation: "Igneous rocks form when molten rock (magma underground or lava at the surface) cools and solidifies. Examples include granite, basalt, and obsidian. Sedimentary rocks form from compressed sediments, and metamorphic rocks form under heat and pressure."
      },
      {
        id: 8,
        question: "What causes the phases of the Moon as seen from Earth?",
        options: [
          "Earth's shadow on the Moon",
          "The Moon's rotation on its axis",
          "The changing position of the Moon relative to Earth and Sun",
          "Clouds blocking our view"
        ],
        correctAnswer: 2,
        explanation: "Moon phases occur because the Moon orbits Earth, and we see different portions of its illuminated half depending on the Moon's position relative to Earth and Sun. Lunar eclipses (not phases) occur when Earth's shadow falls on the Moon."
      }
    ]
  },
  {
    id: 9,
    title: "Military Intelligence Vocabulary",
    description: "Master essential vocabulary used in military intelligence and operations. These words are crucial for understanding orders and communications.",
    category: "Word Knowledge",
    timeLimit: 10,
    questions: [
      {
        id: 1,
        question: "VIGILANT most nearly means:",
        options: ["Watchful", "Tired", "Aggressive", "Confused"],
        correctAnswer: 0,
        explanation: "VIGILANT means watchful and alert, especially to detect danger. This quality is essential for military sentries and security personnel who must remain aware of their surroundings."
      },
      {
        id: 2,
        question: "COVERT most nearly means:",
        options: ["Open", "Secret", "Loud", "Official"],
        correctAnswer: 1,
        explanation: "COVERT means secret or concealed, not openly shown. Covert operations are conducted in secret, often by special forces or intelligence agencies."
      },
      {
        id: 3,
        question: "RESILIENT most nearly means:",
        options: ["Weak", "Flexible", "Able to recover quickly", "Resistant to change"],
        correctAnswer: 2,
        explanation: "RESILIENT means able to recover quickly from difficulties or setbacks. Military personnel must be resilient to adapt to challenging conditions and bounce back from adversity."
      },
      {
        id: 4,
        question: "OBSOLETE most nearly means:",
        options: ["Modern", "Outdated", "Efficient", "Required"],
        correctAnswer: 1,
        explanation: "OBSOLETE means outdated or no longer in use. Military equipment and tactics can become obsolete as technology advances and new strategies are developed."
      },
      {
        id: 5,
        question: "RECONNAISSANCE most nearly means:",
        options: ["Retreat", "Survey for military purposes", "Attack", "Defense"],
        correctAnswer: 1,
        explanation: "RECONNAISSANCE is military observation or survey of an area to gather information about enemy positions, terrain, or resources. Often shortened to 'recon,' it's a critical intelligence-gathering activity."
      },
      {
        id: 6,
        question: "METICULOUS most nearly means:",
        options: ["Careless", "Quick", "Extremely careful and precise", "Average"],
        correctAnswer: 2,
        explanation: "METICULOUS means showing great attention to detail and being extremely careful and precise. This trait is vital for tasks like weapons maintenance, mission planning, and equipment inspections."
      },
      {
        id: 7,
        question: "TACTICAL most nearly means:",
        options: ["Strategic for immediate goals", "Long-term", "Emotional", "Accidental"],
        correctAnswer: 0,
        explanation: "TACTICAL refers to actions carefully planned to achieve a specific military end or short-term goal. Tactical decisions focus on immediate objectives, while strategic decisions address long-term goals."
      },
      {
        id: 8,
        question: "SUBORDINATE most nearly means:",
        options: ["Superior", "Equal", "Lower in rank", "Independent"],
        correctAnswer: 2,
        explanation: "SUBORDINATE means lower in rank or position, or under the authority of another. Understanding chain of command and subordinate relationships is fundamental to military organization."
      },
      {
        id: 9,
        question: "PROFICIENT most nearly means:",
        options: ["Beginner", "Skilled and competent", "Interested", "Confused"],
        correctAnswer: 1,
        explanation: "PROFICIENT means skilled, competent, or expert in a particular area or activity. Military personnel must become proficient in their assigned duties and weapon systems through training and practice."
      },
      {
        id: 10,
        question: "EXPEDITE most nearly means:",
        options: ["Delay", "Speed up", "Cancel", "Complicate"],
        correctAnswer: 1,
        explanation: "EXPEDITE means to speed up a process or make something happen more quickly. In military operations, commanders may need to expedite supply deliveries, troop movements, or mission timelines."
      }
    ]
  },
  {
    id: 10,
    title: "Military Math Operations",
    description: "Master essential mathematics concepts used in military logistics, navigation, and tactical planning.",
    category: "Mathematics Knowledge",
    timeLimit: 12,
    questions: [
      {
        id: 1,
        question: "A military convoy needs to travel 240 miles. If they maintain an average speed of 45 mph for the first 3 hours, then increase to 60 mph, how many more hours will it take to complete the journey?",
        options: ["1.5 hours", "2 hours", "2.5 hours", "3 hours"],
        correctAnswer: 0,
        explanation: "First, calculate distance covered in first 3 hours: 45 × 3 = 135 miles. Remaining distance: 240 - 135 = 105 miles. Time to cover remaining distance at 60 mph: 105 ÷ 60 = 1.75 hours = 1.5 hours."
      },
      {
        id: 2,
        question: "Solve for x: 3x - 7 = 2x + 11",
        options: ["x = 4", "x = 9", "x = 18", "x = 14"],
        correctAnswer: 2,
        explanation: "Subtract 2x from both sides: 3x - 2x - 7 = 11, which gives x - 7 = 11. Add 7 to both sides: x = 18. Check: 3(18) - 7 = 54 - 7 = 47, and 2(18) + 11 = 36 + 11 = 47."
      },
      {
        id: 3,
        question: "A rectangular military training field is 180 feet long and 120 feet wide. What is the area of the field in square yards?",
        options: ["2,400 square yards", "21,600 square yards", "7,200 square yards", "1,200 square yards"],
        correctAnswer: 0,
        explanation: "First, find area in square feet: 180 × 120 = 21,600 square feet. Since 1 yard = 3 feet, 1 square yard = 9 square feet. Convert: 21,600 ÷ 9 = 2,400 square yards."
      },
      {
        id: 4,
        question: "A triangular formation has a base of 24 meters and a height of 15 meters. If the angle at the base is 90°, what is the area of the triangle?",
        options: ["360 square meters", "180 square meters", "195 square meters", "240 square meters"],
        correctAnswer: 1,
        explanation: "The formula for the area of a triangle is A = (1/2) × base × height. A = (1/2) × 24 × 15 = (1/2) × 360 = 180 square meters."
      },
      {
        id: 5,
        question: "A supply depot received 3/4 of its ammunition shipment on Monday and 2/5 of the shipment on Tuesday. What fraction of the total shipment has been received?",
        options: ["5/9", "23/20", "1 3/20", "6/20"],
        correctAnswer: 2,
        explanation: "Add the fractions: 3/4 + 2/5. Find common denominator (20): 15/20 + 8/20 = 23/20. Convert to mixed number: 23/20 = 1 3/20, meaning they received the full shipment plus an additional 3/20 (likely an accounting correction or separate order)."
      },
      {
        id: 6,
        question: "If a soldier completes 85% of a 20-mile march, how many miles remain?",
        options: ["3 miles", "2.5 miles", "3.5 miles", "4 miles"],
        correctAnswer: 0,
        explanation: "85% completed means 15% remains. Calculate 15% of 20 miles: 0.15 × 20 = 3 miles. Alternatively: 85% of 20 = 17 miles completed, so 20 - 17 = 3 miles remain."
      },
      {
        id: 7,
        question: "Simplify: (2³ × 2⁴) ÷ 2⁵",
        options: ["2²", "2³", "4", "8"],
        correctAnswer: 2,
        explanation: "When multiplying powers with the same base, add exponents: 2³ × 2⁴ = 2⁷. When dividing powers with the same base, subtract exponents: 2⁷ ÷ 2⁵ = 2². Calculate 2² = 4."
      },
      {
        id: 8,
        question: "Evaluate: 6 + 3 × (8 - 2)² ÷ 4",
        options: ["33", "27", "54", "15"],
        correctAnswer: 0,
        explanation: "Follow order of operations (PEMDAS): First, parentheses: (8 - 2) = 6. Then exponent: 6² = 36. Then multiply/divide left to right: 3 × 36 = 108, then 108 ÷ 4 = 27. Finally, add: 6 + 27 = 33."
      }
    ]
  },
  {
    id: 11,
    title: "Combat Electronics: Field Communication Systems",
    description: "Master electronic principles critical for military communications and equipment",
    category: "Electronics Information",
    timeLimit: 10,
    questions: [
      {
        id: 1,
        question: "A tactical radio operates at 12 volts and draws 2 amperes of current. According to Ohm's Law, what is the circuit's resistance?",
        options: [
          "4 ohms",
          "6 ohms",
          "10 ohms",
          "24 ohms"
        ],
        correctAnswer: 1,
        explanation: "Using Ohm's Law: R = V/I = 12V / 2A = 6 ohms. This fundamental relationship helps troubleshoot communication equipment in the field."
      },
      {
        id: 2,
        question: "What is the relationship between voltage, current, and resistance in an electrical circuit?",
        options: [
          "Voltage = Current / Resistance",
          "Voltage = Current × Resistance",
          "Voltage = Resistance / Current",
          "Voltage = Current + Resistance"
        ],
        correctAnswer: 1,
        explanation: "Ohm's Law states V = I × R (Voltage equals Current times Resistance). This is the foundation of all electrical circuit analysis and essential for military electronics technicians."
      },
      {
        id: 3,
        question: "What is the primary function of a resistor in an electronic circuit?",
        options: [
          "Store electrical charge",
          "Limit or control current flow",
          "Allow current in one direction only",
          "Amplify electrical signals"
        ],
        correctAnswer: 1,
        explanation: "Resistors limit or control the flow of electric current in a circuit. They're used to protect sensitive components, divide voltages, and set operating points in military electronics."
      },
      {
        id: 4,
        question: "A capacitor's primary function in a circuit is to:",
        options: [
          "Convert AC to DC power",
          "Amplify radio signals",
          "Store and release electrical energy",
          "Reduce circuit resistance"
        ],
        correctAnswer: 2,
        explanation: "Capacitors store electrical energy in an electric field and release it when needed. They're critical in power supplies, signal filtering, and timing circuits in military equipment."
      },
      {
        id: 5,
        question: "In a series circuit with three 10-ohm resistors, what is the total resistance?",
        options: [
          "3.33 ohms",
          "10 ohms",
          "20 ohms",
          "30 ohms"
        ],
        correctAnswer: 3,
        explanation: "In series circuits, total resistance equals the sum of individual resistances: Rtotal = R1 + R2 + R3 = 10 + 10 + 10 = 30 ohms. Current has only one path through all components."
      },
      {
        id: 6,
        question: "A parallel circuit has two branches with resistances of 20 ohms and 30 ohms. What is the total circuit resistance?",
        options: [
          "12 ohms",
          "25 ohms",
          "50 ohms",
          "600 ohms"
        ],
        correctAnswer: 0,
        explanation: "In parallel: 1/Rtotal = 1/R1 + 1/R2 = 1/20 + 1/30 = 3/60 + 2/60 = 5/60. Therefore Rtotal = 60/5 = 12 ohms. Parallel circuits provide multiple paths for current flow."
      },
      {
        id: 7,
        question: "What safety precaution is most important when working on electronic equipment?",
        options: [
          "Wear rubber gloves at all times",
          "Work in complete darkness",
          "Disconnect power and verify it's off before servicing",
          "Use only plastic tools"
        ],
        correctAnswer: 2,
        explanation: "Always disconnect power and verify it's off before working on electronics. Use a multimeter to confirm zero voltage. This prevents electric shock, which can be fatal, and protects equipment from damage."
      },
      {
        id: 8,
        question: "When troubleshooting a communication device that won't power on, what should you check first?",
        options: [
          "Replace all internal components",
          "Check power source, fuses, and connections",
          "Disassemble the entire unit",
          "Update the software"
        ],
        correctAnswer: 1,
        explanation: "Start with the basics: verify power source voltage, check fuses for continuity, inspect connections for corrosion or looseness. This systematic approach saves time and prevents unnecessary repairs in field conditions."
      }
    ]
  },
  {
    id: 12,
    title: "Military Intelligence: Reading Comprehension",
    description: "Sharpen your comprehension skills with military-focused passages",
    category: "Paragraph Comprehension",
    timeLimit: 15,
    questions: [
      {
        id: 1,
        passage: "Military leadership requires more than just giving orders. Effective leaders must inspire trust, communicate clearly, and make difficult decisions under pressure. They must also understand the strengths and limitations of their personnel, adapting their approach to different situations and individuals.\n\nA good military leader balances mission objectives with the welfare of their troops, knowing that success depends on both tactical excellence and unit morale. This balance is particularly challenging during extended operations where fatigue and stress can impact performance. Leaders must remain vigilant for signs of strain within their units while maintaining focus on operational goals.\n\nThe most successful military leaders lead by example, demonstrating the same standards of conduct and performance they expect from their subordinates. This approach builds credibility and fosters a culture of mutual respect that strengthens unit cohesion under the most demanding circumstances.",
        question: "What is the main idea of this passage?",
        options: [
          "Military leaders should focus only on tactical decisions",
          "Effective military leadership involves multiple skills and considerations",
          "Communication is the only important skill for military leaders",
          "Military leaders must prioritize mission objectives above all else"
        ],
        correctAnswer: 1,
        explanation: "The passage emphasizes that military leadership requires 'more than just giving orders' and lists multiple essential qualities including inspiration, communication, decision-making, and balancing mission objectives with troop welfare. This demonstrates that effective leadership involves multiple skills and considerations."
      },
      {
        id: 2,
        passage: "The Global Positioning System (GPS) revolutionized military navigation when it became fully operational in 1995. Originally developed by the Department of Defense in the 1970s, GPS represents one of the most significant technological advances in modern warfare. The system uses a constellation of satellites orbiting Earth at precise altitudes to provide accurate location data anywhere on the planet.\n\nGround-based receivers calculate their position by measuring signals from multiple satellites simultaneously. By analyzing the time it takes for signals to travel from at least four satellites, receivers can determine latitude, longitude, altitude, and even velocity with remarkable precision. This triangulation process occurs continuously, providing real-time position updates.\n\nToday, GPS technology has become essential for coordinating troop movements, guiding precision munitions, and conducting search and rescue operations. Military forces rely on GPS for everything from basic navigation to complex targeting systems. The technology's importance is so great that military planners must account for the possibility of GPS denial or jamming in hostile environments.",
        question: "According to the passage, when did GPS become fully operational?",
        options: [
          "1985",
          "1990",
          "1995",
          "2000"
        ],
        correctAnswer: 2,
        explanation: "The passage explicitly states that GPS 'became fully operational in 1995.' This is a direct fact stated in the first sentence of the passage."
      },
      {
        id: 3,
        passage: "Physical fitness is a cornerstone of military readiness and operational effectiveness. Service members must maintain cardiovascular endurance, muscular strength, and flexibility to perform their duties under the most demanding conditions. The physical requirements of military service extend far beyond basic fitness, encompassing the ability to function effectively while carrying heavy loads, operating in extreme environments, and maintaining performance during extended periods of high stress.\n\nRegular physical training programs serve multiple critical purposes beyond simple conditioning. These programs prepare soldiers for the immediate physical demands of combat operations while simultaneously building mental resilience and fostering unit cohesion. The shared challenge of rigorous training creates bonds between service members and develops the mental toughness required to persevere through adversity.\n\nThe military's comprehensive fitness standards ensure that all personnel can meet operational requirements, from carrying wounded comrades to safety to maintaining sustained operations in challenging environments. These standards are regularly updated based on operational experience and research to reflect the actual physical demands faced by service members in modern military operations.",
        question: "What is the main idea of this passage?",
        options: [
          "Military fitness standards are too demanding",
          "Physical fitness serves multiple critical purposes in military service",
          "Cardiovascular endurance is the most important fitness component",
          "Mental resilience can only be built through physical training"
        ],
        correctAnswer: 1,
        explanation: "The passage describes physical fitness as 'a cornerstone of military readiness' and explains multiple benefits: physical performance, mental resilience, unit cohesion, and mission capability. The main idea is that physical fitness serves multiple critical purposes, not just one aspect."
      },
      {
        id: 4,
        passage: "Military acronyms and specialized terminology serve as highly efficient communication tools in high-pressure operational situations. Terms like 'SITREP' (situation report) and 'CASEVAC' (casualty evacuation) allow personnel to convey complex information quickly and precisely, saving valuable time when every second counts. This abbreviated communication style has evolved over decades of military operations, with each term carefully designed to eliminate ambiguity and ensure clear understanding across all units.\n\nHowever, the overuse of military jargon can create significant communication barriers, particularly when working with civilian agencies, coalition partners from other nations, or local populations. What seems clear to military personnel may be completely incomprehensible to those outside the military culture. This communication gap has led to misunderstandings and coordination failures in joint operations.\n\nEffective military communicators develop the judgment to know when technical terminology enhances communication and when plain language is more appropriate. This adaptability is especially important in modern operations that frequently involve cooperation with multiple agencies and organizations, each with their own communication styles and terminology.",
        question: "According to the passage, what does 'CASEVAC' stand for?",
        options: [
          "Casual evacuation",
          "Casualty evaluation",
          "Casualty evacuation",
          "Case evacuation"
        ],
        correctAnswer: 2,
        explanation: "The passage directly defines 'CASEVAC' as 'casualty evacuation' when explaining military acronyms as efficient communication tools."
      },
      {
        id: 5,
        passage: "Night vision technology gives military forces a significant tactical advantage in darkness and low-light conditions. These devices amplify available light sources, including moonlight, starlight, and even infrared radiation, allowing soldiers to see clearly in near-total darkness. The technology has evolved significantly since its first deployment in World War II, with each generation offering improved resolution, sensitivity, and reliability.\n\nModern night vision systems use sophisticated image intensifier tubes that collect photons from the environment and convert them into electrons. These electrons are then multiplied thousands of times through a microchannel plate before being converted back into visible light on a phosphor screen. The green image commonly associated with night vision is actually a design choice, as the human eye can distinguish more shades of green than any other color. This amplification process allows personnel to conduct operations, navigate terrain, and identify targets in conditions where the naked eye would be nearly blind.\n\nWhile invaluable for nighttime operations and surveillance missions, these systems have important limitations that operators must understand. Night vision devices require some ambient light to amplify and have significant limitations in complete darkness, such as in caves or windowless buildings. They can also be temporarily blinded or damaged by sudden exposure to bright light sources like flashlights or vehicle headlights. Additionally, they cannot see through smoke, fog, or heavy rain as effectively as thermal imaging systems. Despite these constraints, night vision technology remains essential equipment for military forces worldwide, providing a decisive edge in combat operations conducted during limited visibility conditions.",
        question: "Based on the passage, what can be inferred about night vision devices?",
        options: [
          "They work equally well in all lighting conditions",
          "They require some ambient light to function effectively",
          "They are only used by special operations forces",
          "They permanently damage users' natural night vision"
        ],
        correctAnswer: 1,
        explanation: "The passage states that night vision devices 'amplify available light, including moonlight and starlight' and mentions they 'have limitations in complete darkness.' This implies they need some existing light source to amplify, meaning they require ambient light to function effectively."
      },
      {
        id: 6,
        passage: "Military logistics is the science of planning and carrying out the movement and maintenance of forces in support of military operations. It represents one of the most complex and critical aspects of warfare, often determining success or failure more than tactical brilliance on the battlefield. During World War II, the phrase 'amateurs talk strategy, professionals talk logistics' gained prominence, highlighting how even brilliant military strategies collapse without the infrastructure to support them. History is filled with examples of powerful armies that failed due to inadequate supply lines or poor logistical planning.\n\nLogistics encompasses supply chain management, transportation coordination, maintenance operations, and resource allocation across multiple domains. This includes everything from ammunition and fuel to food, medical supplies, spare parts, and personnel replacements. Modern military logistics requires coordinating air, sea, and land transportation networks while managing vast inventories and anticipating future needs based on operational plans. The complexity increases exponentially during joint operations involving multiple service branches or coalition forces from different nations, each with their own supply requirements and coordination challenges.\n\nWithout adequate logistics support, even the most skilled and motivated combat units cannot sustain prolonged operations effectively. Tanks become useless without fuel, soldiers cannot fight without ammunition, and wounded personnel suffer without medical supplies. The ability to deliver the right supplies to the right place at the right time, in the right quantities, often determines the outcome of military campaigns. This principle has remained constant throughout history, from ancient Roman legions building supply depots along their conquest routes to modern military forces using sophisticated computer systems to track supplies in real-time across global theaters of operation.",
        question: "In this passage, the word 'encompasses' most nearly means:",
        options: [
          "Excludes",
          "Includes",
          "Simplifies",
          "Contradicts"
        ],
        correctAnswer: 1,
        explanation: "In context, 'encompasses' means 'includes' or 'comprises.' The passage uses it to explain that logistics includes supply chain management, transportation coordination, and resource allocation. The word indicates that these elements are contained within the broader concept of logistics."
      }
    ]
  }

];

export default quizzes;
